import { useRouter } from 'next/router';
import { Link } from '@/core/routing/components/Link';
import { routes } from '@/core/routing/routes/routes.gb';
import { isB2B } from '@/core/settings/utils';
import { Button } from '@/core/tamagoshiTailwind/components/Button/Button';
import { CrossIcon } from '@/core/tamagoshiTailwind/icons/CrossIcon';
import { B2bMulticolorDarkHorizontalLogo } from '@/core/tamagoshiTailwind/logos/b2b/B2bMulticolorDarkHorizontalLogo';
import { B2cMulticolorDarkHorizontalLogo } from '@/core/tamagoshiTailwind/logos/b2c/B2cMulticolorDarkHorizontalLogo';
interface Props {
  backUrl?: string;
  backText?: string;
  disabled?: boolean;
  onBackAction?: () => void;
}
export const FunnelHeader = ({
  backUrl,
  backText,
  onBackAction,
  disabled = false
}: Props) => {
  const router = useRouter();

  // we currently need this behavior because signup.tsx is using this component, and it's using a function to go back instead of the backUrl
  // when PEPE_UNIFY_AUTH campaign is done they'll no longer use the funnelPage component, so we can remove this and use the backUrl only
  // we should also use NavigationButton instead of Button when we remove this

  const onClick = () => {
    if (onBackAction) {
      onBackAction();
    } else if (backUrl) {
      router.push(backUrl);
    }
  };
  return <header className="h-[40px] text-center desktop:h-[72px]">
      <div className="relative bg-foundation-inverted p-s desktop:p-m">
        {(backUrl || onBackAction) && backText && <Button variant="link" size="M" text={backText} icon={CrossIcon} disabled={disabled} onClick={onClick} className="absolute top-1/2 -translate-y-1/2" />}
        <Link href={routes.home} className={disabled ? 'pointer-events-none' : ''}>
          {isB2B() ? <B2bMulticolorDarkHorizontalLogo className="h-[22px] desktop:h-[40px]" /> : <B2cMulticolorDarkHorizontalLogo className="h-[22px] desktop:h-[40px]" />}
        </Link>
      </div>
    </header>;
};